import React from 'react';
import ReactDOM from 'react-dom';
import './app/config/style.css';
import RouterComponent from './app/config/router';
import AppProvider from './app/context';
import { captureGclid } from './app/utils/hubspotTracking';

// Capture gclid on initial page load
captureGclid();

ReactDOM.render(
    <React.StrictMode>
        <div className="App">
            {/* Skip link for accessibility */}
            <a href="#main-content" style={{
                position: 'absolute',
                left: '-9999px',
                top: '0',
                zIndex: 9999,
                padding: '8px 16px',
                backgroundColor: '#56B2E3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '10px'
            }} onFocus={(e) => {
                e.target.style.left = '0';
            }} onBlur={(e) => {
                e.target.style.left = '-9999px';
            }}>
                Skip to main content
            </a>
            <div className="App-body">
                <AppProvider>
                    <RouterComponent />
                </AppProvider>
            </div>
        </div>
    </React.StrictMode>,
    document.getElementById('root')
);
;